declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../models/api_response_model';
import { ApiRequestModel } from '../../../models/api_request_model';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HCPService } from '../../../services/hcp.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { ActorService } from '../../../services/actor.service';
import { FDService } from '../../../services/fd.service';
import { ConsultantMapPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { SaveMaterialBatchInfoRequest, SaveMaterialBatchRequest, GenericProcPostRequest, S_Methods, SaveMaterialDetailsInfoRequest, EditMaterialDetailsInfoRequest, LongCodeTypeValueController, LongCodeTypeValueRequest, EditCodeTypeValueRequest, SaveCodeTypeValueRequest } from '../../../models/actor/actor';

@Component({
  selector: 'ngbeditcodetypevalue2',
  templateUrl: './editcodetypevalue2.modal.html',
  styleUrls: ['./editcodetypevalue2.modal.scss']
})

export class NgbEditCodetypeValue2Modal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  public isRequesting: boolean;
  @Input() CodeType: string;
  @Input() Code: number;
  @Input() LongValue: string;
  @Input() ShortValue: string;

  public UpdatedLongValue: string;
  public UpdatedShortValue: string;

  public ApiResData: ApiResponseModel;
  CurrentEditCodeTypeValueRequest: EditCodeTypeValueRequest;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }

  ngOnInit() {
    this.CurrentEditCodeTypeValueRequest = new EditCodeTypeValueRequest();
    this.CurrentEditCodeTypeValueRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.UpdatedLongValue = this.LongValue;
    this.UpdatedShortValue = this.ShortValue;
}

  SaveCodeTypeValue() {
    this.StartRefreshing();
    var saveReq = new SaveCodeTypeValueRequest();
    saveReq.ConditionalOperator = 2;
    saveReq.CodeTypeValueCode = this.Code;
    saveReq.CodeType = this.CodeType;
    saveReq.LongValue = this.UpdatedLongValue;
    saveReq.ShortValue = this.UpdatedShortValue;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.SaveCodeTypeValues(saveReq).subscribe(
      (result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          this.activeModal.close('Save click');
        } else {
          this.stopRefreshing();
          alertFunctions.AlertParam(this.ApiResData.ErrorData || "Failed to update.");
        }
      },
      (error) => {
        this.stopRefreshing();
        alertFunctions.AlertParamEr(error);
      }
    );
  }

  MaterialGroupCode: number = 0;
  public MaterialGroupName: string;
  onAssignedToActorCodesurgeon2(event: any) {

    if (event != null) {
      this.MaterialGroupName = event;
    }

  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
